import { useQuery } from "@tanstack/react-query";
import { useZohoAuthContext } from "context/ZohoAuthContext";

export const useGetUsers = () => {
  const { initZoho } = useZohoAuthContext();

  const { data: users } = useQuery({
    queryKey: ["crmUsers"],
    staleTime: Infinity,
    enabled: initZoho,
    queryFn: async () => {
      const resp = await window.ZOHO.CRM.API.getAllUsers({ Type: "AllUsers" });
      // return resp;
      const modified = resp?.users?.map(({ id, full_name }) => ({
        id,
        name: full_name,
      }));
      return modified;
    },
    // select: (data) => {
    //   const modified = data?.users?.map(({ id, full_name }) => ({
    //     id,
    //     name: full_name,
    //   }));
    //   return modified;
    // },
  });

  // return { users, defaultUser: [users?.[0]] };
  return users;
};
